import { SvgIcon } from '@mui/material';
import { SMPalette } from '@nx-smartmonkey/ui';

interface OtherProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function Other({ color = SMPalette.grey1, style = {} }: OtherProps) {
  return (
    <SvgIcon viewBox="0 0 22.34 23.25" style={{ width: `24px`, ...style }}>
      <g>
        <path
          fill={color}
          d="m11.17,22.62C5.11,22.62.17,17.69.17,11.62S5.11.62,11.17.62s11,4.93,11,11-4.93,11-11,11Zm0-20.6C5.88,2.03,1.58,6.33,1.58,11.62s4.3,9.6,9.6,9.6,9.6-4.3,9.6-9.6S16.46,2.03,11.17,2.03Z"
        />
        <path
          fill={color}
          d="m6.07,13.53c-1.05,0-1.91-.85-1.91-1.91s.85-1.91,1.91-1.91,1.91.85,1.91,1.91h0c0,1.05-.86,1.91-1.91,1.91Zm0-2.42c-.28,0-.51.23-.51.51,0,.28.23.51.51.51s.51-.23.51-.51-.23-.51-.51-.51Z"
        />
        <path
          fill={color}
          d="m11.17,13.53c-1.05,0-1.91-.85-1.91-1.91s.85-1.91,1.91-1.91,1.91.85,1.91,1.91h0c0,1.05-.86,1.91-1.91,1.91Zm0-2.42c-.28,0-.51.23-.51.51,0,.28.23.51.51.51s.51-.23.51-.51-.23-.51-.51-.51Z"
        />
        <path
          fill={color}
          d="m16.28,13.53c-1.05,0-1.91-.85-1.91-1.91s.85-1.91,1.91-1.91,1.91.85,1.91,1.91h0c0,1.05-.86,1.91-1.91,1.91Zm0-2.42c-.28,0-.51.23-.51.51,0,.28.23.51.51.51s.51-.23.51-.51-.23-.51-.51-.51Z"
        />
      </g>
    </SvgIcon>
  );
}
